import { createSlice } from "@reduxjs/toolkit";

const initialState = { info: [], danger: [], success: [], warning: [] };

export const slice = createSlice({
	name: "flashes",
	initialState,
	reducers: {
		removeAll: () => ({ ...(initialState || {}) }),
		add: (state, { payload: { type: flashType, id, ...restOfFlashMessage } }) => {
			// The global axios interceptor and a screen's own onError can both flash the same failure;
			// a flash whose id is already showing is not stacked a second time.
			if (id && (state?.[flashType] || []).some((flash) => flash?.id === id)) return state;
			return {
				...(state || {}),
				[flashType]: [
					...(state?.[flashType] || []),
					{ id, createdAt: new Date().getTime(), ...restOfFlashMessage },
				],
			};
		},
		remove: (state, { payload: { type: flashType, message } }) => {
			let index = [...(state[flashType] || [])].findIndex((o) => message?.id && o?.id === message?.id);
			return {
				...(state || {}),
				...(index >= 0 && {
					[flashType]: [
						...(state[flashType].slice(0, index) || []),
						...(state[flashType].slice(index + 1) || []),
					],
				}),
			};
		},
	},
});

export const flashesSelector = (state) => state?.flashes || {};

export const { actions, reducer } = slice;

export default reducer;
